import React, { useEffect, useState } from 'react'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { Link, useParams } from 'react-router-dom'
import Loader from '../../../components/Loader'
import OfficeImg from '../../../assets/office.png'

const AddedParent = () => {
  const [parent, setParent] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)

  const { name } = useParams()

  useEffect(() => {
    const getParentStore = async () => {
      try {
        setIsLoading(true)
        const response = await api.get(`/stores/${name}/manage/parent`)
        console.log("res",response)
        setIsLoading(false)
        setParent(response.data)
      } catch (error) {
        setIsLoading(false)
        toast.error(error.response.data.message)
      } finally { setIsLoading(false) }
    }

    getParentStore()
  }, [name])

  const handleRemove = async () => {
    try {
      const response = await api.patch(`/${name}/parent`)
      if (response) {
        setParent({})
        toast.success("parent business removed")
      }
    } catch (error) {
      toast.error(error.response.data.message)
    }
  }
  return (
    <div className='parent-org-card'>
      {isLoading && <Loader />}
      {
        parent && <div className="parent-org-info">
          <img src={parent?.logo ? parent.logo : OfficeImg} alt="" />
          <div className="parent-desc">
            <Link to={`/${parent.name}`}>
              <h3>{parent.name}</h3>
            </Link>
            <p>
              {parent.description
                ? parent.description.length > 50
                  ? `${parent.description.substring(0, 50)}...`
                  : parent.description
                : "No description available"}
            </p>

            <button className="parent-org-card-btn" onClick={() => handleRemove(parent._id)}>{!isLoading ? "Remove" : "..."}</button>
          </div>
        </div>
      }
      {!parent && !isLoading && <p className='not-foung-msg'>Business has no parent added</p>}
    </div>
  )
}

export default AddedParent